import { Checkbox } from "antd";
import Paper from "components/ui/Paper";
import Tables from "components/ui/Table";
import React from "react";

const CanadianBonds = ({ bonds }) => {
  return (
    <Paper>
      <div className="flex items-center gap-2 md:gap-4 justify-between mb-4">
        <div className="flex items-center gap-1">
          <div className="text-sm md:text-xl font-bold">US Bonds</div>
          <div><img className="w-2" src='/img/down.svg' alt="" /></div>
        </div>
        <div className="flex items-center gap-2 text-[8px] md:text-xs">
          <div className="flex items-center gap-1">
            <u className="text-[#33C3DF] font-normal">Sovereign Debt Monitor</u>
            <div className="border-r-[2px] h-6 border-[#A3AED0]"></div>
          </div>
          <div className="flex items-center gap-1">
            <input type="check box" checked={true} className="h-[12px] w-[12px]  rounded-full border-[1px] border-black" />
            <div>Sovereign</div>
            <div className="border-r-[2px] h-6 border-[#A3AED0]"></div>
          </div>
          <div className="flex items-center gap-1">
            <input type="check box" className="h-[12px] w-[12px]  rounded-full border-[1px] border-black" />
            <div>Provincials</div>
          </div>
          <div className="flex items-center gap-1 text-[#A3AED0] font-semibold">
            <Checkbox />
            <div>Spd to Benchmark</div>
          </div>
        </div>
        <div className="flex items-center gap-2 text-[8px] md:text-xs text-[#A3AED0]  font-semibold">
          <div className="flex items-center gap-1">
            <div>Export</div>
            <div><img src='/img/down-gray.svg' alt="" /></div>
          </div>

          <div className="flex items-center gap-1">
            <div>3M</div>
            <div><img src='/img/down-gray.svg' alt="" /></div>
          </div>

          <div className="flex items-center gap-1">
            <div>Settings</div>
            <div><img src='/img/down-gray.svg' alt="" /></div>
          </div>
        </div>
      </div>
      <Tables bonds={bonds} />
    </Paper >
  );
};

export default CanadianBonds;
